import { render, staticRenderFns } from "./CarouselDialog.vue?vue&type=template&id=4c99ecf6&scoped=true"
import script from "./CarouselDialog.vue?vue&type=script&lang=js"
export * from "./CarouselDialog.vue?vue&type=script&lang=js"
import style0 from "./CarouselDialog.vue?vue&type=style&index=0&id=4c99ecf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99ecf6",
  null
  
)

export default component.exports